export const Cookie = {
    TOKEN: "id_token",
    PKCE_STATE: "pkce_state",
    CODE_VERIFIER: "code_verifier",
    CODE_CHALLENGE: "code_challenge",
    EXPIRATION_TIME: 60,
    THEME: "theme",
}